import { Controller } from "@hotwired/stimulus"

// Phase 2.7 Tier 2 — Carry-Forward modal + general series UX glue.
// The modal partial (`meetings/_carry_forward_modal.html.erb`) hosts
// the form; this controller toggles the modal's visibility, handles
// the select-all / select-none shortcuts, and wires the backdrop
// click-to-close pattern documented in CLAUDE.md.
export default class extends Controller {
  static targets = ["carryForwardModal", "carryForwardForm", "itemCheckbox"]

  openCarryForward() {
    if (!this.hasCarryForwardModalTarget) return
    this.carryForwardModalTarget.classList.remove("hidden")
    document.addEventListener("keydown", this._onKeydown)
  }

  hideModal() {
    if (this.hasCarryForwardModalTarget) {
      this.carryForwardModalTarget.classList.add("hidden")
    }
    document.removeEventListener("keydown", this._onKeydown)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  selectAll() {
    this.itemCheckboxTargets.forEach(cb => {
      if (!cb.disabled) cb.checked = true
    })
  }

  deselectAll() {
    this.itemCheckboxTargets.forEach(cb => {
      if (!cb.disabled) cb.checked = false
    })
  }

  initialize() {
    this._onKeydown = (e) => { if (e.key === "Escape") this.hideModal() }
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }
}
